import { destInfoModalAtom } from '@/commons/constants';
import { Order, PlanDest } from '@/types/plan';
import { Divider, Modal, Typography } from '@mui/material';
import { GridCloseIcon } from '@mui/x-data-grid';
import { atom, useAtom } from 'jotai';
import styled from 'styled-components';
import { useEffect } from 'react';
import SingleMode from './SingleMode';
import MultiMode from './MultiMode';

const ModalWrap = styled.div<{ mode: string }>`
  position: absolute;
  top:50%;
  left:50%;
  transform: translate(-50%, -50%);
  width: ${({ mode }) => (mode === 'SINGLE' ? '80%' : '35%')};
  height: ${({ mode }) => (mode === 'SINGLE' ? '90%' : '25%')};
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  .head{
    padding: 0.5rem;
    width: 100%;
    height: 3rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background:rgba(82, 133, 164, 0.87);
    color: #ffffff;
  }
`;

interface DestInfoProps {
  target: PlanDest[];
  setList?: React.Dispatch<React.SetStateAction<Order[]>>;
}

export const destInfoModifyListAtom = atom<PlanDest[]>();

export default function DestInfo({ target, setList }: DestInfoProps) {
  const [destInfoModal, setDestInfoModal] = useAtom(destInfoModalAtom);
  const [modifyInfo, setModifyInfo] = useAtom(destInfoModifyListAtom);

  const handleClose = () => {
    setDestInfoModal(false);
  };

  useEffect(() => {
    setModifyInfo(target);
  }, [target]);

  useEffect(() => {
    if (modifyInfo && modifyInfo.length > 0) {
      if (target !== modifyInfo) {
        setList && setList(modifyInfo);
        setDestInfoModal(false);
      }
    }
  }, [modifyInfo]);

  return (
    <Modal open={destInfoModal} onClose={handleClose}>
      <>
        {modifyInfo && modifyInfo.length > 0 && (
          <ModalWrap mode={modifyInfo.length === 1 ? 'SINGLE' : 'MULTI'}>
            <div className="head">
              <Typography variant="h5">배송지 정보 수정</Typography>
              <GridCloseIcon onClick={handleClose} />
            </div>
            <Divider />
            {modifyInfo.length === 1 && <SingleMode />}
            {modifyInfo.length > 1 && <MultiMode />}
          </ModalWrap>
        )}
      </>
    </Modal>
  );
}
